export default {
  name: 'FormDescription',

  props: {
    label: String
  }
}
